import { render } from "./YourPersonalDetails.vue?vue&type=template&id=64e25bb6"
import script from "./YourPersonalDetails.vue?vue&type=script&lang=js"
export * from "./YourPersonalDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rulez/Dropbox/Projects/SimpleW/rulez/onboarding2101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__